import {ACTION_UPDATE_PREVIEW} from '../actions/preview';

const DEFAULT_STATE = {
    total: null,
    perFilter: [],
};

export default function previewReducer(state, action) {
    if (!state) {
        state = {...DEFAULT_STATE};
    }

    switch (action.type) {
        case ACTION_UPDATE_PREVIEW:
            state = {
                ...state,
                total: action.total,
                perFilter: action.perFilter,
            };
            break;
    }

    return state;
}
